import React, { useEffect, useState } from 'react';
import { Box, Layout, PrimaryButton, Text, Title } from '@src/shared/ui';
import {
  BreadcrumbFaq,
  TitleFaq,
  FaqHeader,
  StepFaq,
  FaqAccordion,
} from './components';
import { ImgMenTravel } from './components/atoms/img-men-travel';
import {
  useNavigationHandlers,
  useScrollHandler,
  useGTM,
} from '@src/shared/hooks';
import { useProposalState } from '@src/shared/hooks';
import { getFaqData, setEtapa } from '@src/shared/zustand';
import { goToByError } from '@src/shared';
import Lottie from 'lottie-react';
import loadingDots from '@src/assets/lotties/loading_dots.json';
import { GTMEvents } from '@src/config/gtm';
import { Etapa } from '@src/shared/models/etapa';

export const FaqPage: React.FC = () => {
  const navigationHandlers = useNavigationHandlers();
  const { scrollToTop } = useScrollHandler();
  const { trackEvent } = useGTM();
  const { proposal } = useProposalState();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setEtapa(Etapa.FAQ);
    trackEvent(GTMEvents.VIEW_FAQ, {
      proposal_id: proposal?.proposalId,
    });

    getFaqData((error) => {
      setLoading(false);
      if (error) {
        goToByError(error, navigationHandlers);

        return;
      }
    });
  }, []);

  useEffect(() => {
    scrollToTop();
  }, [scrollToTop]);

  if (loading) {
    return (
      <div
        style={{
          height: '100vh',
          width: '100vw',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Lottie
          animationData={loadingDots}
          loop={true}
          autoplay={true}
          rendererSettings={{
            preserveAspectRatio: 'xMidYMid meet',
          }}
          style={{
            height: '24px',
            width: '64px',
          }}
        />
      </div>
    );
  }

  return (
    <Layout
      header={{
        continueButton: true,
        iconLeft: 'arrow-left',
      }}
      beforeGrid={<FaqHeader />}
      afterGrid={<FaqAccordion />}
    >
      <BreadcrumbFaq />
      <TitleFaq />
      <ImgMenTravel
        className={`
          hidden
          col-span-5

          md:flex
          md:max-h-[602px]
          md:min-w-[672px]
          md:w-[672px]
          md:-mb-[160px]
        `}
      />
      <StepFaq />
      <Title
        fontSize='2xl'
        color='neutral70'
        className={`
          col-span-4
          mt-12
          text-center

          sm:tracking-[-0.48px]
          sm:text-[32px]
          sm:col-span-8

          md:col-start-3
        `}
      >
        Com o Boleto Parcelado PaGol, sua viagem dos sonhos se torna realidade
        sem pesar no seu bolso!
      </Title>

      <Box
        className={`
          mt-8
          mb-12
          col-span-4
          flex
          justify-center

          sm:mb-20
          sm:col-span-8

          md:col-span-12
          `}
      >
        <PrimaryButton
          onClick={navigationHandlers.toHome}
          className={`
          h-16
          w-full

          sm:max-w-[360px]
          `}
        >
          <Text color='white' fontSize='md' fontWeight='bold'>
            Continuar o parcelamento
          </Text>
        </PrimaryButton>
      </Box>
    </Layout>
  );
};
